// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__1FCEO","myle-emr-logo":"Logo_myle-emr-logo__QKdnN","md":"Logo_md__iJthi"};